module.exports = __webpack_public_path__ + "img/2.da0dd3f5.png";